import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray_250};
  border-radius: 4px;
  margin-top: 8px;
  overflow-y: auto;

  .MuiListItem-button:hover {
    background-color: ${({ theme }) => theme.colors.background};
    cursor: pointer;
  }

  .selected .MuiListItemText-primary {
    color: ${({ theme }) => theme.colors.primary};
  }

  .listContainer {
    max-height: 300px;
    overflow-y: auto;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: red;

  .MuiSvgIcon-root {
    font-size: 1rem;
  }
`;

export const MessageContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray_275};
`;
